import { Params, PermissionModel } from '@typings';
import { API_ROOT } from '@constants';
import { axios } from '@features';
import { ConfigState } from '@slices';
import { path, removeEmptyProperties } from '@utils';

export const getConfig = async () => {
  return axios.get<never, ConfigState>(`${API_ROOT}/config`);
};

export const getPermissions = ({
  usersUrl = path.create(API_ROOT, 'users'),
  username,
  uri,
  path: restPath,
}: Params.GetPermissions) => {
  return axios.get<never, PermissionModel[]>(
    path.create(usersUrl, username, 'permissions', restPath),
    { params: { uri } },
  );
};

export const shareAccess = ({
  action,
  uri,
  usersUrl,
  username,
}: Params.ShareAccess) => {
  const payload = [{ action, uri }];

  return axios.post(path.create(usersUrl, username, 'permissions'), payload);
};

export const unshareAccess = ({
  uri,
  usersUrl,
  username,
}: Params.UnshareAccess) =>
  axios.delete(path.create(usersUrl, username, 'permissions'), {
    params: { uri },
  });

export const buyCredits = ({
  organizationName,
  amountInCents,
  cancelUrl,
  successUrl,
}: Params.BuyCredits) => {
  const payload = removeEmptyProperties({
    org_name: organizationName,
    amount_in_cents: amountInCents,
    success_url: successUrl,
    cancel_url: cancelUrl,
  });

  return axios.post<never, { checkoutUrl: string }>(
    `${API_ROOT}/payments/stripe/checkout`,
    payload,
  );
};
